import useHasExperiment from ':cloud/hooks/useHasExperiment';

export function useIsPaymasterErc20Enabled() {
  return useHasExperiment('aug_2024_paymaster_erc20', 'treatment');
}
